export default __webpack_public_path__ + "static/media/badge1.0d52b04b.svg";